import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	relatedWorkHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	summaryText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noItems: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	relatedWorkHeading: {
		id: 'version-progress.related-work-heading.related-work-heading',
		defaultMessage: 'Related work',
		description: 'Title for a section of the UI that shows the progress of the related work items',
	},
	summaryText: {
		id: 'version-progress.related-work-heading.summary-text',
		defaultMessage: '{numNonPlaceholders} of {totalCount} added',
		description: 'Summary of the related work items in a version',
	},
	noItems: {
		id: 'version-progress.related-work-heading.no-items',
		defaultMessage: 'None added',
		description: 'Indicates that there are no related work items in the version',
	},
});
export default messages;
